<script>
const columns = [
    {
        key: 'photo',
        title: 'Foto',
        align: 'center',
        scopedSlots: {customRender: 'photo'},
    }, {
        key: 'name',
        title: 'Nama Lengkap',
        align: 'center',
        scopedSlots: {customRender: 'name'}
    }, {
        key: 'businessResult',
        title: 'Business Result',
        align: 'center',
        scopedSlots: {customRender: 'businessResult'},
        children: [
            {
                key: 'PRF-BRE-FIN-FUN',
                title: 'Funding',
                align: 'center',
                scopedSlots: {customRender: 'prf_bre_fin_fun'},
            }, {
                key: 'PRF-BRE-FIN-LEN',
                title: 'Lending',
                align: 'center',
                scopedSlots: {customRender: 'prf_bre_fin_len'},
            }, {
                key: 'PRF-BRE-FIN-FUA',
                title: 'Funding Activity',
                align: 'center',
                scopedSlots: {customRender: 'prf_bre_fin_fua'},
            }, {
                key: 'PRF-BRE-FIN-LEA',
                title: 'Lending Activity',
                align: 'center',
                scopedSlots: {customRender: 'prf_bre_fin_lea'},
            },
        ]
    }, {
        key: 'businessProcess',
        title: 'Business Process',
        align: 'center',
        scopedSlots: {customRender: 'businessProcess'},
        children: [
            {
                key: 'PRF-BPR-BUI-MKT',
                title: 'Bidang Pemasaran',
                align: 'center',
                scopedSlots: {customRender: 'prf_bpr_bui_mkt'},
            }, {
                key: 'PRF-BPR-BUI-CRD',
                title: 'Bidang Perkredtan',
                align: 'center',
                scopedSlots: {customRender: 'prf_bpr_bui_crd'},
            }, {
                key: 'PRF-BPR-BUI-CSO',
                title: 'Bidang Layanan & Operasional',
                align: 'center',
                scopedSlots: {customRender: 'prf_bpr_bui_cso'},
            },
        ]
    }, {
        key: 'PRF-SOC',
        title: 'Soft Competency',
        align: 'center',
        scopedSlots: {customRender: 'prf_soc'}
    }
]

export default {
    data() {
        return {
            columns,
            loading: false,
            dateStart: null,
            dateEnd: null,
            items: [],
            originalCategories: [],
            filters: {
                month: null
            },
        }
    },
    created() {
        this.dateStart = this.moment(this.$laravel.training.date_start)
        this.dateEnd = this.moment(this.$laravel.training.date_end)
        this.filters.month = this.defaultMonth
    },
    methods: {
        getItems() {
            let params = {
                user_hash: this.$laravel.user.hash,
                recap_type: 'evaluator',
                categories: 1,
            }

            if (this.filters.month !== null){
                params.date = this.filters.month.format('YYYYMM')
            }

            this.loading = true
            this.$http
                .get(this.routeUri('api.recap.activity-score.attendants_result') + '?' + this.$qs.stringify(params))
                .then(response => this.processDataItems(response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        onChange(date, dateString) {
            this.filters.month = date
        },
        processDataItems(data) {
            this.items = data.attendants
            this.originalCategories = data.categories
        },
        getMonitoringValue(slot, record) {
            let key = slot.replaceAll('_', '-').toUpperCase()
            let counter = this.categories[key].length

            if (key.startsWith('PRF-SOC') && record.activities[0].scores.length > 1) {
                let scores = record.activities[0].scores
                let soc = _.find(scores, (i) => i.scoreable.code === key)
                if (_.isObject(soc)) {
                    return soc.breakdown['score_' + this.defaultMonth.format('YYYYMM')]  > 0 ? [ 'indicator-block', 'indicator-success'] : ['indicator-block', 'indicator-warning']
                }
                return ['indicator-block', 'indicator-danger']
            } else if ((key.startsWith('PRF-BRE') || key.startsWith('PRF-BPR')) && record.activities[0].achievements.length > 1) {
                let scores = record.activities[0].achievements

                let soc = _.filter(scores, function(i) {
                    if (_.isObject(i.objective.indicator)) {
                        return i.objective.indicator.code === key && i.status === 'approved'
                    }
                    return false
                })

                if (soc.length >= counter) {
                    return ['indicator-block', 'indicator-success']
                } else if (soc.length <= 0) {
                    return ['indicator-block', 'indicator-danger']
                } else {
                    return ['indicator-block', 'indicator-warning']
                }
            }
            return ['indicator-block', 'indicator-danger']
        }
    },
    computed: {
        categories() {
            if (this.originalCategories.length > 0) {
                let categories = {}

                this.originalCategories.forEach(function(item, key) {
                    if (item.indicator !== null) {
                        if (categories.hasOwnProperty(item.indicator.code)) {
                            categories[item.indicator.code].push(key)
                        } else {
                            categories[item.indicator.code] = [ key ]
                        }
                    }

                    if (item.perspective !== null) {
                        if (categories.hasOwnProperty(item.perspective.code)) {
                            categories[item.perspective.code].push(key)
                        } else {
                            categories[item.perspective.code] = [ key ]
                        }
                    }

                    if (item.aspect !== null) {
                        if (categories.hasOwnProperty(item.aspect.code)) {
                            categories[item.aspect.code].push(key)
                        } else {
                            categories[item.aspect.code] = [ key ]
                        }
                    }
                })

                return categories
            }

            return {}
        },
        defaultMonth() {
            let current = this.moment()

            if (current.isBetween(this.dateStart, this.dateEnd, 'month')) {
                current.subtract(1, 'months')
                if (current.isSameOrBefore(this.dateStart, 'month')) {
                    return current
                } else if (current.isSameOrAfter(this.dateEnd, 'month')) {
                    return this.dateEnd
                }

                return current
            } else if (current.isSameOrBefore(this.dateStart, 'month')) {
                return this.dateStart
            }

            return this.dateEnd
        }
    },
    watch: {
        'filters.month': {
            immediate: false,
            deep: false,
            handler: function(n,o) {
                this.getItems()
            }
        }
    }
}
</script>

<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Performance Mentor">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <div style="margin: 20px 0;" class="text-right">
            <a-month-picker format="MMM YYYY" :defaultValue="defaultMonth" v-model="filters.month" @change="onChange" />
        </div>

        <a-card type="inner" size="small" style="margin-top: 24px">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :columns="columns" :dataSource="items" rowKey="hash" :pagination="false" bordered>
                    <div slot="photo" slot-scope="record" style="text-align: center">
                        <a-avatar :src="record.photo" shape="square" :size="64" icon="user" />
                    </div>

                    <div slot="name" slot-scope="record" class="text-left">
                        <h4>
                            <a-icon type="user" /> {{ record.name }} <br />
                            <a :href="`tel:${record.mobile_phone}`"><a-icon type="phone" /></a> {{ record.mobile_phone }}
                        </h4>
                    </div>

                    <div slot="prf_bre_fin_fun" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_bre_fin_fun', r)">&nbsp;</div>
                    </div>
                    <div slot="prf_bre_fin_len" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_bre_fin_len', r)">&nbsp;</div>
                    </div>
                    <div slot="prf_bre_fin_fua" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_bre_fin_fua', r)">&nbsp;</div>
                    </div>
                    <div slot="prf_bre_fin_lea" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_bre_fin_lea', r)">&nbsp;</div>
                    </div>
                    <div slot="prf_bpr_bui_mkt" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_bpr_bui_mkt', r)">&nbsp;</div>
                    </div>
                    <div slot="prf_bpr_bui_crd" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_bpr_bui_crd', r)">&nbsp;</div>
                    </div>
                    <div slot="prf_bpr_bui_cso" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_bpr_bui_cso', r)">&nbsp;</div>
                    </div>
                    <div slot="prf_soc" slot-scope="r" class="text-center indicator-wrapper">
                        <div :class="getMonitoringValue('prf_soc', r)">&nbsp;</div>
                    </div>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>
